<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="overflow-auto">
        <div id="list-container">
          <table class="ts-table" style="min-width:1520px">
            <thead>
              <tr>
                <th style="width:250px" class="ts-uppercase ts-border-b">{{ $t('preInvoice.feeType') }}</th>
                <th style="width:250px" class="ts-uppercase ts-border-b">{{ $t('preInvoice.feeName') }}</th>
                <th style="width:250px" class="ts-uppercase ts-border-b">{{ $t('preInvoice.description') }}</th>
                <th style="width:250px" class="ts-uppercase ts-border-b">{{ $t('preInvoice.dateFrom') }}</th>
                <th style="width:250px" class="ts-uppercase ts-border-b">{{ $t('preInvoice.dateTo') }}</th>
                <th style="width:110px" class="ts-uppercase ts-border-b">{{ $t('preInvoice.qty') }}</th>
                <th style="width:110px;" class="ts-uppercase ts-border-b">{{ $t('preInvoice.fee') }}</th>
                <th style="width:120px" class="text-center ts-uppercase ts-border-b">
                  {{ $t('preInvoice.discountType') }}
                </th>
                <th style="width:120px" class="text-center ts-uppercase ts-border-b">
                  {{ $t('preInvoice.discount') }}
                </th>
                <th style="width:110px" class="text-center ts-uppercase ts-border-b">
                  {{ $t('preInvoice.vat') }}
                </th>
                <th style="width:110px" class="ts-uppercase ts-border-b">{{ $t('preInvoice.amount') }}</th>
              </tr>
              <!-- <TableProgressBar v-show="loading" :columnLength="11" /> -->
            </thead>
            <tbody>
              <tr v-for="(item, index) in model.inv_detail_list" :key="index">
                <td>
                  <a-select
                    v-model="item.fee_type_id"
                    showSearch
                    :disabled="notAvailable"
                    style="width: 100%"
                    :options="
                      getFeeTypeLists(item.fee_type_id).map(el => ({
                        value: el.fee_type_id,
                        label: el.fee_type_name
                      }))
                    "
                    optionFilterProp="children"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    @change="onFeeTypeChange(item)"
                  />
                  <div
                    class="validate"
                    v-if="
                      errors.has('inv_detail_list.' + index + '.fee_type_id')
                    "
                  >
                    {{
                      errors.first('inv_detail_list.' + index + '.fee_type_id')
                    }}
                  </div>
                </td>
                <td>
                  <a-select
                    v-model="item.fee_setup_id"
                    showSearch
                    style="width: 100%"
                    :maxTagTextLength="30"
                    :options="getFeeSetupByFeeType(item.fee_type_id)"
                    optionFilterProp="children"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    @change="onFeeSetupChange(item)"
                  />
                  <div
                    class="validate"
                    v-if="
                      errors.has('inv_detail_list.' + index + '.fee_setup_id')
                    "
                  >
                    {{
                      errors.first('inv_detail_list.' + index + '.fee_setup_id')
                    }}
                  </div>
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    v-model="item.fee_description"
                  />
                </td>
                <td class="ts-whitespace-no-wrap">
                  <a-date-picker
                    mode="date"
                    v-model="item.fee_start_date"
                    format="DD-MM-YYYY"
                    @change="startDateChange(item)"
                  />
                </td>
                <td>
                  <a-date-picker
                    mode="date"
                    v-model="item.fee_end_date"
                    format="DD-MM-YYYY"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    v-model="item.quantity"
                    @input="calculate()"
                  />
                  <div
                    class="validate"
                    v-if="errors.has('inv_detail_list.' + index + '.quantity')"
                  >
                    {{ errors.first('inv_detail_list.' + index + '.quantity') }}
                  </div>
                </td>
                <td>
                  <input
                    type="number"
                    readonly
                    class="form-control"
                    v-model="item.fee_amount"
                  />
                </td>
                <td>
                  <a-select
                    v-model="item.discount_type"
                    style="width: 100%"
                    :options="[
                      { value: '$', label: '$' },
                      { value: '%', label: '%' }
                    ]"
                    @change="calculate"
                  />
                  <div
                    class="validate"
                    v-if="
                      errors.has('inv_detail_list.' + index + '.discount_type')
                    "
                  >
                    {{
                      errors.first(
                        'inv_detail_list.' + index + '.discount_type'
                      )
                    }}
                  </div>
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    v-model="item.discount_rate"
                    @input="calculate()"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    v-model="item.vat_rate"
                    @input="calculate()"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    readonly
                    v-model="item.total_amount"
                  />
                  <div
                    class="validate"
                    v-if="
                      errors.has('inv_detail_list.' + index + '.total_amount')
                    "
                  >
                    {{
                      errors.first('inv_detail_list.' + index + '.total_amount')
                    }}
                  </div>
                </td>
                <td class="text-center">
                  <a href="#" @click.prevent="removeRow(item)">
                    <i class="py-2 fa fa-trash text-red"></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td class="ts-text-left ts-p-1 ts-w-12">
                <button 
                  class="ts-bg-blue-500 ts-text-white ts-rounded-full ts-p-1 ts-flex hover:ts-bg-blue-600
                  ts-items-center ts-justify-center ts-shadow-sm hover:ts-shadow-md ts-outline-none focus:ts-outline-none"
                  @click.prevent="addNewRow"
                  aria-label="Add new row"
                >
                  <i class="fa fa-plus ts-text-xs"></i>
                </button>
              </td>
              </tr>
              <tr>
                <td colspan="10" class="text-right">
                  <strong>{{ $t('preInvoice.total') }}:</strong>
                </td>
                <td class="text-right">
                  <u>
                    <strong>{{ model.total_amount }}</strong>
                  </u>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import TableProgressBar from '@/components/common/TsTable/TableProgressBar'
import { Errors } from 'form-backend-validation'
import { ceil, debounce, round, sumBy } from 'lodash'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'preInvoiceItemList',
  props: ['value', 'studentInfo', 'validate'],
  components: {
    TableProgressBar
  },
  data() {
    return {
      model: {},
      loading: false,
      newRow: {
        fee_type_id: null,
        fee_setup_id: null,
        fee_description: null,
        quantity: 1,
        fee_start_date: null,
        fee_end_date: null,
        payment_term_id: null,
        duration_in_month: 0,
        fee_amount: 0,
        discount_type: '%',
        discount_rate: 0,
        discount_amount: 0,
        discount_reason: null,
        total_amount: 0,
        vat_rate: 0,
        vat_amount: 0,
        amount_include_vat: 0,
        ac_term_id: null,
        grade_id: null,
        shift_id: null
      },
      errors: new Errors(),
      feeTypes: [],
      feeSetupsWithDetail: {}
    }
  },
  created() {
    this.model = this.value
    this.loading = true
    this.getFeeType({
      fields: {
        setup_payment_fee_types: 'fee_type_id,fee_type_name'
      },
      page: -1
    }).finally(() => (this.loading = false))
  },
  computed: {
    ...mapState('preInvoice', ['room_type_id']),
    notAvailable() {
      return !(
        (this.model.student_id != '') | null &&
        (this.model.grade_id != null) | undefined &&
        (this.model.ac_term_id != null) | undefined
      )
    }
  },
  methods: {
    ...mapActions('preInvoice', [
      'getFeeType',
      'preInvoiceFormView',
    ]),
    addNewRow() {
      this.model.inv_detail_list.push(_.clone(this.newRow))
    },
    removeRow(row) {
      this.model.inv_detail_list.splice(
        this.model.inv_detail_list.indexOf(row),
        1
      )
      this.model.total_amount = _.sumBy(
        this.model.inv_detail_list,
        'total_amount'
      )
      this.calculate()
    },
    async studentSubscription() {
      this.loading = true
      let response = await this.preInvoiceFormView({
            ac_status_id: this.model.ac_status_id,
            grade_id: this.model.grade_id,
            ac_term_id: this.model.ac_term_id,
            student_id: this.model.student_id,
            end_date_of_term: this.model.term_stop,
            inv_date: moment().format('DD-MM-YYYY'),
            room_type_id: this.room_type_id,
            fnName: 'getStudentSubscripton',
          })
      this.model.inv_detail_list = []
      await Promise.all(
        Object.values(response.getStudentSubscripton)
          .flat()
          .map(async el => {
            var row = _.clone(this.newRow)
            row.fee_type_id = el.fee_type_id
            row.fee_setup_id = el.fee_setup_id
            const rowDetail = this.model.inv_detail_list.filter(
              d => d.fee_type_id == row.fee_type_id
            ).length

            if (rowDetail == 0) {
              this.model.inv_detail_list.push(row)
              await this.onFeeTypeChange(el, 1)
              this.onFeeSetupChange(row)
            }
          })
      )
      this.loading = false
    },
    async onFeeTypeChange(feeType, waiting = 0) {
      if (!this.feeSetupsWithDetail.hasOwnProperty(feeType.fee_type_id)) {
        if (!waiting) {
          this.loading = true
        }
        let response = await this.preInvoiceFormView({
            ac_status_id: this.model.ac_status_id,
            grade_id: this.model.grade_id,
            ac_term_id: this.model.ac_term_id,
            student_id: this.model.student_id,
            end_date_of_term: this.model.term_stop,
            fee_type_id: feeType.fee_type_id,
            invoice_date: this.model.pre_inv_date,
            inv_date: moment().format('DD-MM-YYYY'),
            room_type_id: this.room_type_id,
            invoice_id: 0,
            fnName: 'getFeeSetupWithDetail',
          })
        if (waiting == 0) {
          this.clearAfterFeeTypeSetupChange(feeType)
        }
        this.feeSetupsWithDetail = Object.assign(
          {},
          this.feeSetupsWithDetail,
          response.getFeeSetupWithDetail
        )
        if (!waiting) {
          this.loading = false
        }
      }
    },
    onFeeSetupChange(item) {
      if(this.feeSetupsWithDetail[item.fee_type_id] == undefined) return []
      this.feeSetupsWithDetail[item.fee_type_id]
        .filter(f => f.fee_setup_id == item.fee_setup_id)
        .forEach(el => {
          item.fee_description = el.fee_name // description is a fee name
          item.quantity = 1
          item.fee_start_date = el.fee_start_date
            ? moment(el.fee_start_date, 'DD-MM-YYYY')
            : null
          item.fee_end_date = el.fee_end_date
            ? moment(el.fee_end_date, 'DD-MM-YYYY')
            : null
          item.payment_term_id = el.payment_term_id
          item.duration_in_month = el.duration_in_month
          item.fee_amount = el.fee_amount
          item.discount_type = '%'
          ;(item.discount_rate = el.discount_rate),
            (item.discount_reason = el.discount_remark)
          item.ac_term_id = el.ac_term_id
          item.grade_id = el.grade_id
          item.shift_id = el.shift_id
        })
      this.calculate()
    },
    clearAfterFeeTypeSetupChange(feeType) {
      ;(feeType.fee_description = ''),
        (feeType.quantity = 1),
        (feeType.fee_setup_id = null),
        (feeType.fee_start_date = null),
        (feeType.fee_end_date = null),
        (feeType.payment_term_id = null),
        (feeType.duration_in_month = null),
        (feeType.fee_amount = 0),
        (feeType.discount_type = '%'), 
        (feeType.discount_rate = 0),
        (feeType.discount_amount = 0),
        (feeType.discount_reason = null),
        (feeType.total_amount = 0),
        (feeType.vat_rate = 0),
        (feeType.vat_amount = 0),
        (feeType.amount_include_vat = 0),
        (feeType.ac_term_id = null),
        (feeType.grade_id = null),
        (feeType.shift_id = null)
    },
    getFeeSetupByFeeType(feeTypeId) {
      let result = this.feeSetupsWithDetail[feeTypeId]
      if (result != undefined) {
        return result.map(el => ({
          value: el.fee_setup_id,
          id: el.fee_setup_id,
          label: el.fee_name
        }))
      }
      return []
    },
    calculate() {
      let price = 0;
      if (this.model.inv_detail_list.length > 0) {
        this.model.inv_detail_list.forEach(item => {
          price = item.fee_amount ? item.fee_amount * item.quantity : 0
          if (item.discount_type == '%') {
            item.discount_amount = item.discount_rate
              ? price * round(item.discount_rate / 100, 4)
              : 0
          }
          if (item.discount_type == '$') {
            item.discount_amount = item.discount_rate
          }
          item.vat_amount =
            ((price - item.discount_amount) * item.vat_rate) / 100
          item.total_amount =
            ceil(price - item.discount_amount, 2) + item.vat_amount
          item.amount_include_vat = ceil(
            price - item.discount_amount + item.vat_amount,
            2
          )
          this.model.total_amount = sumBy(
            this.model.inv_detail_list,
            'total_amount'
          )
        })
      } else {
        this.model.total_amount = 0
      }
    },
    startDateChange(item) {
      if ([0, 3, 6, 12].includes(item.duration_in_month)) return;

      item.fee_end_date = moment(
        item.fee_start_date.format('DD-MM-YYYY'),
        'DD-MM-YYYY'
      ).add(item.duration_in_month, 'M')
        .subtract(1, 'day'); 
    },
    getFeeTypeLists(currentFeeTypeId) {

    if (!this.model.inv_detail_list || this.model.inv_detail_list.length === 0) {
        return this.feeTypes;
      }

      // Get all fee type IDs except the current one
      const feeTypeIds = this.model.inv_detail_list
        .filter(el => el.fee_type_id !== currentFeeTypeId)
        .map(el => el.fee_type_id);
      
      // Filter out all used fee types except the current one
      return this.feeTypes
    },
    fetchFeeType(){
      this.preInvoiceFormView({
            ac_status_id: this.model.ac_status_id,
            grade_id: this.model.grade_id,
            ac_term_id: this.model.ac_term_id,
            student_id: this.model.student_id,
            end_date_of_term: this.model.term_stop,
            fnName: 'feeType',
          })
          .then((response) => {
              this.feeTypes = response.feeType
            })
    }
  },
  watch: {
    'model.grade_id': debounce(function(grade_id) {
      this.feeSetupsWithDetail = []
      if (grade_id != undefined && this.model.ac_term_id) {
        this.studentSubscription()
        this.fetchFeeType()
      } else {
        this.model.inv_detail_list = []
      }
    }),
    'model.ac_term_id': debounce(function(ac_term_id) {
      this.feeSetupsWithDetail = []
      if (ac_term_id != undefined && this.model.grade_id) {
        this.studentSubscription()
        this.fetchFeeType()
      } else {
        this.model.inv_detail_list = []
      }
    }),
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
#list-container {
  white-space: nowrap;
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 10;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
</style>
